import { ActionTypes } from './actionTypes';
import type {
  ClearEtaRoute,
  LoadEtaRouteFailed,
  LoadEtaRouteRequest,
  LoadEtaRouteSucceeded,
  LoadEtaVehiclesFailed,
  LoadEtaVehiclesRequest,
  LoadEtaVehiclesSucceeded,
} from './actions';
import type { EtaVehicle } from './types';

import type { Destination } from '@cobliteam/common-types';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';

export const loadEtaVehiclesRequest = (address: string, devices: DeviceFragment[]): LoadEtaVehiclesRequest => ({
  type: ActionTypes.LOAD_ETA_VEHICLES_REQUEST,
  payload: { address, devices },
});

export const loadEtaVehiclesSucceeded = (destination: Destination, etaVehicles: EtaVehicle[]): LoadEtaVehiclesSucceeded => ({
  type: ActionTypes.LOAD_ETA_VEHICLES_SUCCEEDED,
  payload: { destination, etaVehicles },
});

export const loadEtaVehiclesFailed = (): LoadEtaVehiclesFailed => ({
  type: ActionTypes.LOAD_ETA_VEHICLES_FAILED,
});

export const loadEtaRouteRequest = (address: string, device: DeviceFragment): LoadEtaRouteRequest => ({
  type: ActionTypes.LOAD_ETA_ROUTE_REQUEST,
  payload: { address, device },
});

export const loadEtaRouteSucceeded = (device: DeviceFragment, route: google.maps.DirectionsRoute): LoadEtaRouteSucceeded => ({
  type: ActionTypes.LOAD_ETA_ROUTE_SUCCEEDED,
  payload: { device, route },
});

export const loadEtaRouteFailed = (): LoadEtaRouteFailed => ({
  type: ActionTypes.LOAD_ETA_ROUTE_FAILED,
});

export const clearEtaRoute = (): ClearEtaRoute => ({
  type: ActionTypes.CLEAR_ETA_ROUTE,
});

export const openEtaDialog = (device?: DeviceFragment) => ({
  type: ActionTypes.OPEN_ETA_DIALOG,
  payload: device,
});

export const closeEtaDialog = () => ({
  type: ActionTypes.CLOSE_ETA_DIALOG,
});
